/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Match_Reason_Listing_CodeInputs */

const cs_import_match_reason_listing_code = /** @type {(inputs: Import_Match_Reason_Listing_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoda podle kódu inzerátu`)
};

const en_import_match_reason_listing_code = /** @type {(inputs: Import_Match_Reason_Listing_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched by listing code`)
};

/**
* | output |
* | --- |
* | "Matched by listing code" |
*
* @param {Import_Match_Reason_Listing_CodeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_match_reason_listing_code = /** @type {((inputs?: Import_Match_Reason_Listing_CodeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Match_Reason_Listing_CodeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_match_reason_listing_code(inputs)
	return cs_import_match_reason_listing_code(inputs)
});